export const min_width = 1148;


// WEBPACK FOOTER //
// src/constants/ui.jsx